module.exports = __webpack_public_path__ + "img/project-11.6ee81745.jpg";